export default __webpack_public_path__ + "static/media/philadelphia-76ers.3a023453.jpeg";